<template>
  <v-container>
    <Snack
      ref="snack"
      :message="snack.message"
      :barColor="snack.barColor"
      :timeout="snack.timeout"
    ></Snack>
    <v-card tile>
      <v-container> {{ gymName }} のデータを表示しています。 </v-container>
    </v-card>
    <v-card>
      <v-tabs v-model="tab" background-color="primary" dark>
        <v-tab v-for="item in items" :key="item.tab">
          {{ item.tab }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <GradeTab @alert="getResult"></GradeTab>
        <AngleTab @alert="getResult"></AngleTab>
        <TagTab @alert="getResult"></TagTab>
        <UpTab :gymid="gymid" @alert="getResult"></UpTab>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>
<script>
/* eslint-disable no-console */
import { db } from "../../plugins/firebase";
import store from "../../stores";
import GradeTab from "@/components/TabItems/Grade";
import AngleTab from "@/components/TabItems/Angle";
import TagTab from "@/components/TabItems/Tag";
import UpTab from "@/components/TabItems/Unknown";
import Snack from "@/components/Alert/Snackbar";

export default {
  name: "admin-problems",
  components: {
    GradeTab,
    AngleTab,
    TagTab,
    UpTab,
    Snack,
  },
  mounted() {
    this.checkState();
  },
  data() {
    return {
      sharedState: store.state,
      snack: {
        message: "",
        barColor: "info",
        timeout: 3000,
      },
      gymid: "",
      tab: null,
      items: [
        { tab: "グレード" },
        { tab: "傾斜" },
        { tab: "タグ" },
        { tab: "アップロード" },
      ],
      gymName: "",
    };
  },
  methods: {
    getResult(value) {
      this.snack.message = value.message;
      this.snack.barColor = value.type;
      this.$refs.snack.show();
    },
    async checkState() {
      await store.setUserAuth();
      if (!this.sharedState.user.isLogin) this.$router.push("signin");
      const result = await db
        .collection("M_GYM")
        .doc(this.sharedState.user.gymid)
        .get();
      const gym = result.data();
      this.gymName = gym.name;
      this.gymid = result.id;
    },
  },
};
</script>
